import { createSlice } from "@reduxjs/toolkit";

export const templateSetSlice = createSlice({
  name: "templateSet",
  initialState: {
    getTemplateSetResult: false,
    getTemplateSetLoading: false,
    getTemplateSetError: false,
    addTemplateSetResult: false,
    addTemplateSetLoading: false,
    deleteTemplateSetResult: false,
  },
  reducers: {
    templateSetReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TEMPLATESET":
          return {
            ...state,
            getTemplateSetResult: payload.data,
            getTemplateSetLoading: payload.loading,
            getTemplateSetError: payload.error,
          };
        case "ADD_TEMPLATESET":
          return {
            ...state,
            addTemplateSetResult: payload.data,
            addTemplateSetLoading: payload.loading,
          };
        case "DELETE_TEMPLATESET":
          return {
            ...state,
            deleteTemplateSetResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { templateSetReducers } = templateSetSlice.actions;

export default templateSetSlice.reducer;
